import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import 'Features/Bundle/components/BundleEnded/BundleEnded.scss';

import BundleEndedRecommendations from 'Features/Bundle/components/BundleEnded/BundleEndedRecommendations';
import EmailSubscribeBox from 'Components/EmailSubscribe/EmailSubscribeBox';

const BundleEnded = ({ franchises, displayType, darkTheme }) =>
  <div className="bundle-ended-container">
    <div className="d-flex justify-content-end align-items-center">
      <div className="bundle-ended m-y-2">
        <p className="ended-title">
          <FormattedMessage id="bundle-ended.bundle-ended" defaultMessage="This bundle has ended" />
        </p>
        <p className="ended-title-sub">
          <FormattedMessage id="bundle-ended.liked-bundles" defaultMessage="Here are a selection of bundles you may like" />
        </p>
        <BundleEndedRecommendations
          franchises={franchises}
          displayType={displayType}
        />
        <Link to="/bundle" className="soldout-link">
          <FormattedMessage id="bundle-ended.click-here" defaultMessage="Click here to view all our latest bundles" />
        </Link>
      </div>
    </div>
    <EmailSubscribeBox
      large
      lightTheme={!darkTheme}
      context="Bundles"
    />
  </div>;

BundleEnded.propTypes = {
  franchises: PropTypes.arrayOf(PropTypes.string),
  displayType: PropTypes.string,
  darkTheme: PropTypes.bool,
};

BundleEnded.defaultProps = {
  franchises: [],
  displayType: '',
  darkTheme: true,
};

export default BundleEnded;
